import React from "react";
import { TextLink } from "./components/TextLink";
import { Text } from "react-native-elements";
import { FONT_SIZE_SECONDARY, colors } from "./styles";
import { TextStyle } from "react-native";

const styles = {
  footerText: {
    fontSize: FONT_SIZE_SECONDARY,
    color: colors.neutral400,
  },
} as const;

export const footerElements = (style?: TextStyle) => {
  const entryStyle = { ...styles.footerText, ...style };
  return [
    <TextLink
      style={entryStyle}
      href="https://www.bomdata.io/legal/privacy-policy"
      type="href"
      target="_blank"
      key="privacy"
    >
      Privacy Policy
    </TextLink>,
    <TextLink
      style={entryStyle}
      href="https://www.bomdata.io/legal/terms-of-use"
      type="href"
      target="_blank"
      key="terms"
    >
      Terms of Use
    </TextLink>,
    <TextLink style={entryStyle} type="route" routeName="Credits" key="credits">
      Credits
    </TextLink>,
    <Text style={entryStyle} key="copyright">
      © BOMdata, Inc.
    </Text>,
  ];
};
